
import React from 'react';

const products = [
  'btr-bar.png',
  'the-good-chocolate.png',
  'real-food-bar.png',
  'joy-days.png',
  'jba.png',
  'nu-skool.png',
  'bella-bars.png',
  'good-idea.png',
  'oobli.png',
  'dr-fuhrman.png',
  'munk-pack.png',
  'suu.png',
  'stanford.png',
  'general-mills.png',
  'teatis.png',
  'homiah.png'
];

const TestedProductsSection: React.FC = () => {
  // Split products into three rows: 5, 6, 5
  const row1 = products.slice(0, 5);
  const row2 = products.slice(5, 11);
  const row3 = products.slice(11, 16);

  // Calculate optimal size based on container dimensions
  // Container is 60vw × 30vh
  // We need to fit 6 items horizontally (max items in a row)
  // We want some gap between items
  const gapSize = '1vw'; // 1% of viewport width for gap
  const numItems = 6; // Maximum items in a row

  // Calculate available space for items (accounting for gaps)
  const availableWidth = `calc((60vw - (${numItems - 1} * ${gapSize})) / ${numItems})`;
  const availableHeight = `calc((30vh - (2 * ${gapSize})) / 3)`; // 3 rows with gaps between

  // Use the smaller of the two to maintain square aspect ratio
  const itemSize = `min(${availableWidth}, ${availableHeight})`;

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-center mb-8">Brands We've Worked With</h2>
        <div
          className="relative mx-auto flex flex-col items-center justify-start"
          style={{
            width: '60vw',
            height: '30vh',
            gap: gapSize,
          }}
        >
          {/* Row 1 */}
          <div
            className="flex items-center"
            style={{ gap: gapSize }}
          >
            {row1.map((product) => (
              <div
                key={product}
                className="transition-transform duration-300 hover:scale-110"
                style={{
                  width: itemSize,
                  height: itemSize,
                }}
              >
                <img
                  src={`/products/${product}`}
                  alt={product.replace('.png', '')}
                  className="w-full h-full object-contain"
                  style={{
                    filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))',
                  }}
                />
              </div>
            ))}
          </div>

          {/* Row 2 - Offset by half an item width */}
          <div
            className="flex items-center"
            style={{ gap: gapSize }}
          >
            {row2.map((product) => (
              <div
                key={product}
                className="transition-transform duration-300 hover:scale-110"
                style={{
                  width: itemSize,
                  height: itemSize,
                }}
              >
                <img
                  src={`/products/${product}`}
                  alt={product.replace('.png', '')}
                  className="w-full h-full object-contain"
                  style={{
                    filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))',
                  }}
                />
              </div>
            ))}
          </div>

          {/* Row 3 */}
          <div
            className="flex items-center"
            style={{ gap: gapSize }}
          >
            {row3.map((product) => (
              <div
                key={product}
                className="transition-transform duration-300 hover:scale-110"
                style={{
                  width: itemSize,
                  height: itemSize,
                }}
              >
                <img
                  src={`/products/${product}`}
                  alt={product.replace('.png', '')}
                  className="w-full h-full object-contain"
                  style={{
                    filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))',
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestedProductsSection;
